import axios from "axios";
import axiosInstance from "../utils/axiosInstance";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const submitApplication = async (formData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/application`, formData);
    return response.data;
  } catch (error) {
    console.error("API submission error:", error);
    throw error;
  }
};

export const updateApplication = async (applicationId, formData) => {
  try {
    const response = await axiosInstance.put(`${API_BASE_URL}/application/${applicationId}`, formData);
    return response.data;
  } catch (error) {
    console.error("API submission error:", error);
    throw error;
  }
};

export const submitCommunity = async (formData, formSource) => {
  try {
    let communityEndPoint = `${API_BASE_URL}/communities/create`;
    if (formSource !== "page") {
      communityEndPoint = `${API_BASE_URL}/communities/createbyAdmin`;
    }
    const response = await axiosInstance.post(communityEndPoint, formData);
    return response.data;
  } catch (error) {
    console.error("API submission error:", error);
    throw error;
  }
};

export const submitBulkCommunity = async (formData) => {
  try {
    let communityEndPoint = `${API_BASE_URL}/communities/createBulkCommunities`;
    const response = await axiosInstance.post(communityEndPoint, formData);
    return response.data;
  } catch (error) {
    console.error("API submission error:", error);
    throw error;
  }
};

export const editCommunity = async (formData) => {
  try {
    const response = await axiosInstance.put(
      `${API_BASE_URL}/communities/${formData.id}`,
      formData
    ); // Adjust URL as needed
    return response.data;
  } catch (error) {
    console.error("API submission error:", error);
    throw error;
  }
};

export const fetchApplications = async (page, pageSize, sortBy, filter) => {
  try {
    const response = await axiosInstance.get("/application/getAll", {
      params: { page, pageSize, sortBy, filter },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching applications:", error);
    throw error;
  }
};

export const fetchApplicationById = async (id, page, pageSize, sortBy, filter) => {
  try {
    const response = await axiosInstance.get(`/application/getByCommunity/${id}`, {
      params: { page, pageSize, sortBy, filter },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching applications:", error);
    throw error;
  }
};

export const fetchCommunities = async (page, pageSize, filter) => {
  try {
    const response = await axiosInstance.get("/communities", {
      params: { page, pageSize, filter },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching communities:", error);
    throw error;
  }
};

export const fetchNearByCommunities = async () => {
  try {
    const response = await axiosInstance.get("/communities/nearby");
    return response.data;
  } catch (error) {
    console.error("Error fetching communities:", error);
    throw error;
  }
};

export const deleteCommunity = async (id) => {
  try {
    const response = await axiosInstance.delete(`/communities/${id}`);
    console.log("Community deleted successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting community:", error);
    throw error;
  }
};

export const deleteApplication = async (id) => {
  try {
    const response = await axiosInstance.delete(`/application/${id}`);
    console.log("Application deleted successfully:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error deleting Application:", error);
    throw error;
  }
};

export const downloadApplication = async (id) => {
  try {
    const response = await axiosInstance.get(`/application/${id}/pdf`, {
      responseType: 'blob',
    });
    
    // Extract filename from Content-Disposition header
    const contentDisposition = response.headers['content-disposition'];
    let filename = `application_${id}.pdf`; // Fallback filename
    
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '');
      }
    }
    
    const link = document.createElement('a');
    const url = window.URL.createObjectURL(new Blob([response.data]));
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading Application:", error);
    throw error;
  }
};

export const fetchInvoices = async (page, pageSize, filter) => {
  try {
    const response = await axiosInstance.get("/invoices", {
      params: { page, pageSize, filter },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching invoices:", error);
    throw error;
  }
};

export const submitInvoice = async (formData) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}/invoices/create`,
      formData
    );
    return response.data;
  } catch (error) {
    console.error("API submission error:", error);
    throw error;
  }
};

export const updateInvoiceStatus = async (invoiceId) => {
  try {
    const response = await axiosInstance.patch(`/invoices/update-status/${invoiceId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching invoices:", error);
    throw error;
  }
};

export const fetchConfigurations = async () => {
  try {
    const response = await axiosInstance.get("/configurations");
    return response.data;
  } catch (error) {
    console.error("Error fetching configurations:", error);
    throw error;
  }
};

export const updateConfigurationValue = async (keyName, value) => {
  try {
    const response = await axiosInstance.put("/configurations", { keyName, value });
    return response.data;
  } catch (error) {
    console.error("Error updating configuration:", error);
    throw error;
  }
};

export const updatePortalApplication = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`/portal/applications/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error("Error updating portal application:", error);
    throw error;
  }
};

export const fetchPortalApplicationById = async (id) => {
  try {
    const response = await axiosInstance.get(`/portal/applications/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching portal application details:", error);
    throw error;
  }
};

export const fetchPortalApplications = async (page, pageSize) => {
  try {
    const response = await axiosInstance.get("/portal/applications", {
      params: { page, pageSize },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching portal applications:", error);
    throw error;
  }
};

export const fetchRegisteredUsers = async (page, pageSize, filter) => {
  try {
    const response = await axiosInstance.get("/users/applicants", {
      params: { page, pageSize, filter },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching registered users:", error);
    throw error;
  }
};

